module.exports = __webpack_public_path__ + "static/media/table.319d04b0.svg";